module.exports = __webpack_public_path__ + "img/3.ac43e984.svg";